import {ScreenProp} from 'src/app/models'
import {WoIncomingScreen} from '../page/Incoming/Screen'
import {WoOutgoingScreen} from '../page/Outgoing/Screen'

type TWoIncomingKeys = keyof typeof WoIncomingScreen
type TWoOutgoingKeys = keyof typeof WoOutgoingScreen

type TKeys = 'WORK_ORDER' | TWoIncomingKeys | TWoOutgoingKeys

const WorkOrderScreens: Record<TKeys, ScreenProp> = {
  WORK_ORDER: {
    PATH: '/work-order',
    TITLE: 'Manajemen WO',
    TITLE_ALT: 'Tugas antar Departemen',
  },

  ...WoIncomingScreen,
  ...WoOutgoingScreen,
}

export default WorkOrderScreens
